import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import ItemHelper from "../../../../services/Menu/services/Item/ItemHelper";
import Analytics from "../../../../services/Common/Analytics/Analytics";
import Pixel from "../../../../services/Common/Analytics/Pixel";
import {RootState} from "../../../../../reducers";
import {getItemGroups, getItems} from "../../../../services/Menu/reducer";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {getCart} from "../../../../services/Cart/reducer";
import {connect, DispatchProp} from "react-redux";
import MenuProductModal from "../../components/Product/MenuProductModal";

interface OwnProps {
    menuId?: number;
}

type Props = ReturnType<typeof mapStateToProps> & DispatchProp & OwnProps;

const MenuProductPage = ({items, config, itemGroups, cart, menuId}: Props) => {
    const [showModal, setShowModal] = useState(true);
    const {id: paramId} = useParams();
    const location = useLocation();
    const id = parseInt(paramId ?? "");
    const item = ItemHelper.getItem(items, id);
    const itemGroup = location.state?.fromVoucher || location.state?.promotionId
        ? undefined
        : ItemHelper.getItemGroup(itemGroups, item?.id);

    useEffect(() => {
        if (!paramId) return;

        const item = ItemHelper.getItem(items, parseInt(paramId));
        if (item) {
            if (location.state && location.state.back) {
                Analytics.selectItem(item);
                Pixel.selectItem(item);
            }
            Analytics.viewItem(item);
            Pixel.viewItem(item);
        }
    }, [paramId]);

    if (!paramId || !item) return <></>;

    return <MenuProductModal show={showModal} config={config} setShow={setShowModal} item={item} itemGroup={itemGroup}
                             menuId={menuId}/>
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    itemGroups: getItemGroups(state.menu),
    cart: getCart(state.cart),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default connector(MenuProductPage);